import React from "react";

import css from "./OfflineView.module.css";
import useManageOfflineView from "./hooks/useManageOfflineView";

function OfflineView() {
  const { mediaElement, t } = useManageOfflineView();

  return (
    <div className={css.container}>
      <div className={css.header}>{t("No internet connection")}</div>
      <div className={css.videoContainer}>{mediaElement}</div>
    </div>
  );
}

export default OfflineView;
